import { render, staticRenderFns } from "./BandejaRequisicion.vue?vue&type=template&id=60afa886"
import script from "./BandejaRequisicion.vue?vue&type=script&lang=js"
export * from "./BandejaRequisicion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports